// ======================================================================
// File Name       : serviceGroup
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SELECT_TARGET_DATA } from "../../constants";
import { commonCallApi } from "../../utils/ApiUtils";

export function postServiceGroupGetList(data) {
  return commonCallApi({
    path: 'servicegroup/GetList',
    data: { ...data },
    enterpriseId: 1,
  });
}

export function postServiceGroupGetServiceRelation(data) {
  return commonCallApi({
    path: 'servicegroup/GetServiceRelation',
    data: { ...data },
    enterpriseId: 1,
  });
}

export function postServiceGroupGetSuperUserRelation(data) {
  return commonCallApi({
    path: 'servicegroup/GetSuperuserRelation',
    data: { ...data },
    enterpriseId: 1,
  });
}

export function postServiceGetList(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'service/GetList',
    data: { ...PARAM_DEFAULT, ...data },
    enterpriseId: 1,
    institutionId: 1,
  });
}

export function postSuperUserGetList(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'superuser/GetList',
    data: { ...PARAM_DEFAULT, ...data },
    enterpriseId: 1,
  });
}

export function postServiceGroupEdit(data) {
  return commonCallApi({
    path: 'servicegroup/Edit',
    data: { ...data },
    enterpriseId: 1,
  });
}

export function postServiceGroupEditServiceRelation(data) {
  return commonCallApi({
    path: 'servicegroup/EditServiceRelation',
    data: { ...data },
    enterpriseId: 1,
  });
}

export function postServiceGroupEditSuperUserRelation(data) {
  return commonCallApi({
    path: 'servicegroup/EditSuperuserRelation',
    data: { ...data },
    enterpriseId: 1,
  });
}
